/* STATE theme — storefront behaviour (Shopify) */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const CFG = window.STATE_THEME || { reveal: true, money: "${{amount}}" };

  /* ---------- money ---------- */
  function money(cents, fmt) {
    fmt = fmt || CFG.money || "${{amount}}";
    function f(n, p, t, d) { p = p || 2; t = t === undefined ? "," : t; d = d === undefined ? "." : d;
      const s = (Math.abs(n) / 100).toFixed(p), parts = s.split(".");
      let i = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "$1" + t);
      return i + (p ? d + parts[1] : ""); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) =>
      k.indexOf("no_decimals") > -1 ? f(cents, 0) : f(cents, 2));
  }
  window.stateMoney = money;

  /* ---------- reveal ---------- */
  if (CFG.reveal) {
    document.documentElement.classList.add("reveal-on");
    const reveal = () => { const vh = innerHeight || 800;
      $$(".reveal:not(.in)").forEach((e) => { if (e.getBoundingClientRect().top < vh * 0.92) e.classList.add("in"); }); };
    window.obsAll = reveal;
    addEventListener("scroll", reveal, { passive: true });
    addEventListener("resize", reveal); addEventListener("load", reveal);
    reveal(); requestAnimationFrame(reveal);
  } else { window.obsAll = function () {}; }

  /* ---------- header solid ---------- */
  const hdr = $("#hdr");
  const hs = () => hdr && hdr.classList.toggle("solid", scrollY > 30);
  hs(); addEventListener("scroll", hs, { passive: true });

  /* ---------- mobile nav ---------- */
  const sheet = $("#msheet");
  $$("[data-burger]").forEach((b) => b.addEventListener("click", () => sheet && sheet.classList.add("show")));
  $$("[data-sheet-close]").forEach((b) => b.addEventListener("click", () => sheet && sheet.classList.remove("show")));
  sheet && $$("a", sheet).forEach((a) => a.addEventListener("click", () => sheet.classList.remove("show")));

  /* ---------- drawer ---------- */
  const overlay = $("#overlay"), drawer = $("#drawer");
  const openCart = () => { overlay && overlay.classList.add("show"); drawer && drawer.classList.add("show"); };
  const closeCart = () => { overlay && overlay.classList.remove("show"); drawer && drawer.classList.remove("show");
    const qv = $("#qvModal"); qv && qv.classList.remove("show"); };
  window.openCart = openCart; window.closeCart = closeCart;
  $$("[data-cart-open]").forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); fetchCart(); openCart(); }));
  $$("[data-cart-close]").forEach((b) => b.addEventListener("click", closeCart));

  /* ---------- toast ---------- */
  let tT; function toast(msg) {
    let t = $("#toast");
    if (!t) { t = document.createElement("div"); t.id = "toast"; t.className = "toast";
      t.innerHTML = '<span class="dot"></span><span class="tm"></span>'; document.body.appendChild(t); }
    t.querySelector(".tm").textContent = msg; t.classList.add("show");
    clearTimeout(tT); tT = setTimeout(() => t.classList.remove("show"), 2200);
  }
  window.toast = toast;

  /* ---------- cart ---------- */
  function renderCart(cart) {
    const body = $("#cartBody"); if (!body) return;
    $$(".cart-count").forEach((e) => { e.textContent = cart.item_count; e.classList.toggle("show", cart.item_count > 0); });
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty-cart"><p style="font-family:var(--font-display);font-weight:800;font-size:1.3rem;color:var(--ink);margin-bottom:6px">your bag is empty.</p><p>pick your state — surge, sculpt or suppress.</p></div>';
      $("#cartFoot").style.display = "none"; return;
    }
    $("#cartFoot").style.display = "block";
    body.innerHTML = cart.items.map((it) => `<div class="line">
      <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') : ''}" alt="${it.product_title}">
      <div style="flex:1">
        <div class="ln-t">${it.product_title}</div>
        <div class="ln-s">${it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title + ' · ' : ''}${money(it.final_price)}</div>
        <div class="qty" style="margin-top:8px">
          <button data-key="${it.key}" data-to="${it.quantity - 1}" aria-label="decrease">−</button>
          <span>${it.quantity}</span>
          <button data-key="${it.key}" data-to="${it.quantity + 1}" aria-label="increase">+</button>
        </div>
      </div>
      <div style="font-family:var(--font-display);font-weight:700">${money(it.final_line_price)}</div>
    </div>`).join("");
    $("#cartSub").textContent = money(cart.total_price);
  }
  function fetchCart() { return fetch("/cart.js").then((r) => r.json()).then(renderCart).catch(() => {}); }
  function changeQty(key, qty) {
    fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }) }).then((r) => r.json()).then(renderCart);
  }
  document.addEventListener("click", (e) => {
    const q = e.target.closest("[data-key]"); if (q) changeQty(q.dataset.key, +q.dataset.to);
  });

  /* add to cart forms */
  document.addEventListener("submit", (e) => {
    const form = e.target.closest("form.js-add"); if (!form) return;
    e.preventDefault();
    const btn = form.querySelector("[type=submit]"); const orig = btn ? btn.innerHTML : "";
    if (btn) { btn.disabled = true; btn.innerHTML = "adding…"; }
    fetch("/cart/add.js", { method: "POST", body: new FormData(form),
      headers: { "Accept": "application/json" } })
      .then((r) => r.json())
      .then((it) => { return fetchCart().then(() => { openCart(); toast((it.product_title || "added") + " added"); }); })
      .catch(() => toast("sorry — couldn't add that"))
      .finally(() => { if (btn) { btn.disabled = false; btn.innerHTML = orig; } });
  });

  /* ---------- accordions ---------- */
  document.addEventListener("click", (e) => {
    const q = e.target.closest(".acc-q"); if (!q) return;
    const it = q.closest(".acc-item"); const open = it.classList.contains("open");
    it.classList.toggle("open");
    const a = it.querySelector(".acc-a"); a.style.maxHeight = open ? "0" : a.scrollHeight + "px";
  });

  /* ---------- sticky add-to-cart ---------- */
  const satc = $("#satc"), anchor = $("#buyAnchor");
  if (satc && anchor) {
    const os = () => satc.classList.toggle("show", anchor.getBoundingClientRect().bottom < 60);
    addEventListener("scroll", os, { passive: true }); os();
  }

  /* ---------- parallax ---------- */
  const px = $$("[data-parallax]");
  if (px.length && !matchMedia("(prefers-reduced-motion:reduce)").matches) {
    const run = () => px.forEach((el) => {
      const speed = parseFloat(el.dataset.parallax) || 0.2;
      const r = el.parentElement.getBoundingClientRect();
      const off = (r.top + r.height / 2 - innerHeight / 2) * -speed;
      el.style.transform = `translate3d(0,${off.toFixed(1)}px,0) scale(1.12)`;
    });
    addEventListener("scroll", run, { passive: true }); addEventListener("resize", run); run();
  }

  /* ---------- hero jar mouse tilt ---------- */
  const stage = $("#heroStage"), jar = $("#heroJar");
  if (stage && jar && !matchMedia("(prefers-reduced-motion:reduce)").matches) {
    stage.addEventListener("pointermove", (e) => {
      const r = stage.getBoundingClientRect();
      jar.style.setProperty("--mx", (((e.clientX - r.left) / r.width - .5) * 16).toFixed(2) + "deg");
      jar.style.setProperty("--my", ((-((e.clientY - r.top) / r.height - .5)) * 12).toFixed(2) + "deg");
    });
    stage.addEventListener("pointerleave", () => { jar.style.setProperty("--mx", "0deg"); jar.style.setProperty("--my", "0deg"); });
  }

  /* ---------- newsletter (Shopify form handles post; just UX) ---------- */
  fetchCart();
})();
